module.exports = __webpack_public_path__ + "img/ic-receive.02ac8c26.png";